import {Component} from 'react'
import {v4 as uuidv4} from 'uuid'

import PasswordItem from '../PasswordItem'

import './index.css'

class PasswordManager extends Component {
  state = {
    website: '',
    username: '',
    password: '',
    passwordsList: [],
    searchInput: '',
    showPasswords: false,
  }

  onChangeWebsite = event => {
    this.setState({
      website: event.target.value,
    })
  }

  onChangeUsername = event => {
    this.setState({
      username: event.target.value,
    })
  }

  onChangePassword = event => {
    this.setState({
      password: event.target.value,
    })
  }

  onChangeSearch = event => {
    this.setState({
      searchInput: event.target.value,
    })
  }

  onChangeShowPasswords = event => {
    this.setState({
      showPasswords: event.target.checked,
    })
  }

  onAddPassword = event => {
    event.preventDefault()

    const {website, username, password} = this.state

    if (website !== '' && username !== '' && password !== '') {
      const newPassword = {
        id: uuidv4(),
        website,
        username,
        password,
      }

      this.setState(prevState => ({
        passwordsList: [...prevState.passwordsList, newPassword],
        website: '',
        username: '',
        password: '',
      }))
    }
  }

  onDeletePassword = id => {
    this.setState(prevState => ({
      passwordsList: prevState.passwordsList.filter(
        eachPassword => eachPassword.id !== id,
      ),
    }))
  }

  renderNoPasswords = () => (
    <div className="no-passwords-container">
      <img
        src="https://assets.ccbp.in/frontend/react-js/no-passwords-img.png"
        alt="no passwords"
        className="no-passwords-image"
      />

      <p className="no-passwords-text">No Passwords</p>
    </div>
  )

  renderPasswords = () => {
    const {passwordsList, searchInput, showPasswords} = this.state

    const filteredPasswords = passwordsList.filter(eachPassword =>
      eachPassword.website.toLowerCase().includes(searchInput.toLowerCase()),
    )

    if (filteredPasswords.length === 0) {
      return this.renderNoPasswords()
    }

    return (
      <ul className="passwords-list">
        {filteredPasswords.map(eachPassword => (
          <PasswordItem
            key={eachPassword.id}
            passwordDetails={eachPassword}
            showPasswords={showPasswords}
            onDeletePassword={this.onDeletePassword}
          />
        ))}
      </ul>
    )
  }

  render() {
    const {
      website,
      username,
      password,
      passwordsList,
      searchInput,
      showPasswords,
    } = this.state

    const passwordsCount = passwordsList.length

    return (
      <div className="app-container">
        <div className="main-container">
          <img
            src="https://assets.ccbp.in/frontend/react-js/password-manager-logo-img.png"
            alt="app logo"
            className="app-logo"
          />

          <div className="add-password-container">
            <form className="password-form" onSubmit={this.onAddPassword}>
              <h1 className="form-heading">Add New Password</h1>

              <div className="input-container">
                <img
                  src="https://assets.ccbp.in/frontend/react-js/password-manager-website-img.png"
                  alt="website"
                  className="input-icon"
                />

                <input
                  type="text"
                  placeholder="Enter Website"
                  value={website}
                  onChange={this.onChangeWebsite}
                  className="input-element"
                />
              </div>

              <div className="input-container">
                <img
                  src="https://assets.ccbp.in/frontend/react-js/password-manager-username-img.png"
                  alt="username"
                  className="input-icon"
                />

                <input
                  type="text"
                  placeholder="Enter Username"
                  value={username}
                  onChange={this.onChangeUsername}
                  className="input-element"
                />
              </div>

              <div className="input-container">
                <img
                  src="https://assets.ccbp.in/frontend/react-js/password-manager-password-img.png"
                  alt="password"
                  className="input-icon"
                />

                <input
                  type="password"
                  placeholder="Enter Password"
                  value={password}
                  onChange={this.onChangePassword}
                  className="input-element"
                />
              </div>

              <button type="submit" className="add-button">
                Add
              </button>
            </form>

            <img
              src="https://assets.ccbp.in/frontend/react-js/password-manager-lg-img.png"
              alt="password manager"
              className="password-manager-image large-image"
            />

            <img
              src="https://assets.ccbp.in/frontend/react-js/password-manager-sm-img.png"
              alt="password manager"
              className="password-manager-image small-image"
            />
          </div>

          <div className="passwords-container">
            <div className="passwords-header">
              <div className="heading-container">
                <h1 className="passwords-heading">Your Passwords</h1>

                <p className="password-count">{passwordsCount}</p>
              </div>

              <div className="search-container">
                <img
                  src="https://assets.ccbp.in/frontend/react-js/password-manager-search-img.png"
                  alt="search"
                  className="search-icon"
                />

                <input
                  type="search"
                  placeholder="Search"
                  value={searchInput}
                  onChange={this.onChangeSearch}
                  className="search-input"
                />
              </div>
            </div>

            <hr className="horizontal-line" />

            <div className="show-password-container">
              <input
                type="checkbox"
                id="showPassword"
                checked={showPasswords}
                onChange={this.onChangeShowPasswords}
              />

              <label htmlFor="showPassword">Show passwords</label>
            </div>

            {this.renderPasswords()}
          </div>
        </div>
      </div>
    )
  }
}

export default PasswordManager
